export const wrapLinksInParagraph = (htmlValue: Document) => {
  const linkElements = htmlValue.querySelectorAll('a')

  linkElements.forEach((linkElement) => {
    const parentP = linkElement.closest('p')
    if (!parentP) {
      const newP = document.createElement('p')
      newP.appendChild(linkElement.cloneNode(true))
      linkElement.replaceWith(newP)
    }
  })
}
